const AUTH_STORAGE_KEYS = [
  'jwtToken',
  'user',
  'userEmail',
  'userFullName',
  'userRole',
  'freshLogin',
];

const LANGUAGE_CODES = new Set(['mk', 'al', 'en', 'tr', 'hr', 'sr', 'de']);

const decodeJwtPayload = (token) => {
  if (typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length !== 3) {
    return null;
  }

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(window.atob(paddedBase64));
  } catch {
    return null;
  }
};

export const clearAuthentication = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event('authChange'));
};

export const hasValidAuthentication = () => {
  const token = localStorage.getItem('jwtToken');
  const payload = decodeJwtPayload(token);
  const isUnexpired = payload
    && typeof payload.exp === 'number'
    && payload.exp * 1000 > Date.now();

  if (token && !isUnexpired) {
    clearAuthentication();
  }

  return Boolean(isUnexpired);
};

export const getLanguageFromPath = (pathname = window.location.pathname) => {
  const language = pathname.split('/')[1];
  return LANGUAGE_CODES.has(language) ? language : 'mk';
};

export const isSafeInternalDestination = (destination) => (
  typeof destination === 'string'
  && destination.startsWith('/')
  && !destination.startsWith('//')
  && !destination.includes('\\')
);

export const saveIntendedDestination = (destination) => {
  if (isSafeInternalDestination(destination)) {
    localStorage.setItem('intendedDestination', destination);
  }
};

export const consumeIntendedDestination = () => {
  const destination = localStorage.getItem('intendedDestination');
  localStorage.removeItem('intendedDestination');
  return isSafeInternalDestination(destination) ? destination : null;
};

export const redirectToLogin = ({ preserveDestination = true } = {}) => {
  const { pathname, search, hash } = window.location;
  const language = getLanguageFromPath(pathname);
  const loginPath = `/${language}/login`;

  if (pathname.endsWith('/login')) {
    return;
  }

  if (preserveDestination) {
    saveIntendedDestination(`${pathname}${search}${hash}`);
  }

  window.location.replace(loginPath);
};
